import { Button } from '@mui/material'
import React, { useState } from 'react'
import './customTeamDetailsCell.css'
import Modal from '@mui/material/Modal'
import { Box } from '@material-ui/core'
import Typography from '@mui/material/Typography'
import TeamMembersDetails from '../../componant/teamMembersDetails/teamMembersDetails'
import ModalWrapper from '../../widgets/modal/modal'
import ButtonWrapper from '../../widgets/button/button'

const CustomTeamDetailsCell = (props: { value: any, actionStatus?: boolean, title?: string }) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = () => {

    setOpen(true)
  };
  const handleClose = () => setOpen(false);
  return (

    <>
      <div className='button-class'>
        <ButtonWrapper className={`view-button`} title={`view`} onClick={handleOpen} />
      </div>
      <ModalWrapper open={open} close={handleClose} children={<TeamMembersDetails onClose={handleClose} members={props} actionStatus={props.actionStatus ? props.actionStatus : false} title={props.title} />} />

    </>
  )
}

export default CustomTeamDetailsCell